<template>
  <div
    class=""
    :class="{
      'electron-note-page-wrap': isElectron,
      'note-page-wrap': !isElectron,
    }"
  >
    <div class="note-page-cont">
      <div class="note-title">
        <p class="lesson-name ellipsis">
          {{ noteInfo.lesson_name }}
        </p>
        <button @click="apiExportNote" v-preventReClick class="download-btn">
          <img src="../../assets/images/icon/download.png" alt="" />
        </button>
      </div>
      <div class="editor-wrap">
        <button v-preventReClick @click="apiSaveNote" class="save-btn">
          保存
        </button>
        <wang-editor
          ref="editor"
          class="editor"
          :value="noteInfo.content || ''"
          placeholder="请填写您的笔记"
          :toolbarKeys="toolbarKeys"
          @created="onEditorCreated"
          @noticeJumpPlayTime="noticeJumpPlayTime"
          @keydown.native="onKeydown"
          :lessonInfo="handleLessonInfo"
        ></wang-editor>
      </div>
    </div>
  </div>
</template>

<script>
import WangEditor from "@saas/components/src/components/wang-editor/Index.vue";
import {
  getNoteDetail,
  saveNote,
  exportNote,
} from "@saas/service-api/src/note";
import { extractTextFromHtml } from "@saas/components/src";
export default {
  data() {
    return {
      isElectron: window.isElectron,
      lessonId: null,
      toolbarKeys: ["insertFormula", "bold", "italic", "underline"],
      editor: null,
      noteInfo: {},
      saving: false,
      exporting: false,
    };
  },
  components: {
    WangEditor,
  },
  mounted() {
    this.lessonId = Number(this.$route.params.lessonId);
    this.apiGetNoteDetail();
  },
  methods: {
    apiSaveNote() {
      if (this.saving) {
        return;
      }
      this.saving = true;
      const { course_id, lesson_id, unit_id } = this.noteInfo;
      let params = {
        content: this.editor.getHtml(),
        course_id,
        lesson_id,
        unit_id,
        summary: extractTextFromHtml(this.editor.getHtml())?.text,
      };
      saveNote(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.message);
          }
          this.saving = false;
        })
        .catch(() => (this.saving = false));
    },
    onKeydown(e) {
      e.stopPropagation();
    },
    onEditorCreated(editor) {
      this.editor = editor;
    },
    // 跳转到指定时间
    noticeJumpPlayTime(time) {
      const { course_id, unit_id, lesson_id } = this.noteInfo;
      const url = `/video-play/${course_id}/${unit_id}/${lesson_id}?time=${time}`;
      if (window.isElectron) {
        this.$router.push({
          path: url,
        });
      } else {
        window.open(url, "_blank");
      }
    },
    async apiGetNoteDetail() {
      let params = { lesson_id: this.lessonId };
      const res = await getNoteDetail(params);
      if (res.code === 1) {
        this.noteInfo = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    apiExportNote() {
      this.loading = this.$loading({
        lock: true,
        text: "PDF生成中",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.6)",
        fullscreen: true,
      });
      let params = {
        id: this.noteInfo.id,
      };
      exportNote(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("PDF生成成功");
            // todo 先直接打开
            if (this.isElectron) {
              window.openUrlByExternal(res.data);
            } else {
              window.open(res.data);
            }
          } else {
            this.$message.error(res.message || "PDF生成失败，请重新下载");
          }
          this.stopLoading();
        })
        .catch(() => {
          this.stopLoading();
          this.$message.error("PDF生成失败，请重新下载");
        });
    },
    stopLoading() {
      this.loading && this.loading.close();
    },
  },
  computed: {
    handleLessonInfo() {
      const { id, course_id, unit_id } = this.noteInfo;
      return {
        lesson_id: id,
        course_id,
        unit_id,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.editor ::v-deep {
  border: none;
  .comp-container__editor-toolbar {
    & > div {
      min-height: 36px;
    }
    border-bottom: 1px solid var(--border-subtle, #f2f3f5);
    .w-e-toolbar {
      background: transparent;

      .w-e-bar-item button {
        color: var(--note-toolbar-icon);
        background-color: transparent;

        svg {
          fill: var(--note-toolbar-icon);
        }

        &:hover {
          color: var(--note-toolbar-icon-hover);
          background-color: var(--note-toolbar-hover-bg);

          svg {
            fill: var(--note-toolbar-icon-hover);
          }
        }

        &.active {
          color: var(--note-toolbar-icon-hover);
          background-color: var(--note-toolbar-active-bg);

          svg {
            fill: var(--note-toolbar-icon-hover);
          }
        }
      }

      .w-e-bar-item > button[data-menu-key="insertFormula"],
      .w-e-bar-item > button[data-menu-key="bold"],
      .w-e-bar-item > button[data-menu-key="italic"],
      .w-e-bar-item > button[data-menu-key="underline"] {
        filter: var(--note-toolbar-icon-filter);

        &:hover,
        &.active {
          filter: var(--note-toolbar-icon-hover-filter);
        }
      }
    }
  }
  .comp-container__editor-content {
    flex: 1;
    overflow-y: auto;
    .w-e-text-container {
      background: transparent;
    }
    .w-e-scroll {
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 2px;
      }
    }
  }
}
.editor-wrap {
  --note-toolbar-icon: var(--mg-text-secondary, #515350);
  --note-toolbar-icon-hover: var(--mg-text-primary, #0d1400);
  --note-toolbar-hover-bg: var(--mg-control-hover-bg, #f8fafc);
  --note-toolbar-active-bg: var(--mg-control-hover-bg, #f8fafc);
  --note-toolbar-icon-filter: none;
  --note-toolbar-icon-hover-filter: none;

  position: relative;
  flex: 1;
  height: 0;

  html.dark &,
  html.theme-dark &,
  html[data-theme="dark"] &,
  #app.dark &,
  #app.theme-dark & {
    --note-toolbar-icon: var(--mg-text-muted, var(--text-muted));
    --note-toolbar-icon-hover: var(--mg-text-primary, var(--text-primary));
    --note-toolbar-hover-bg: transparent;
    --note-toolbar-active-bg: var(--mg-border-subtle, var(--border-subtle));
    --note-toolbar-icon-filter: invert(0.65) brightness(1.5);
    --note-toolbar-icon-hover-filter: invert(1);
  }

  .save-btn {
    position: absolute;
    width: 50px;
    height: 24px;
    background: var(--card-bg, #ffffff);
    border-radius: 4px;
    border: 1px solid var(--border-subtle, #f2f3f5);
    font-size: 12px;
    color: var(--text-primary, #0d1400);
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 6px;
    right: 8px;
    z-index: 2;
  }
}
.note-page-wrap {
  --note-download-icon-filter: none;
  --note-download-icon-hover-filter: none;

  width: 100%;
  height: 100vh;
  background: var(--page-bg, #f7f8fa);
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  .note-page-cont {
    width: 100%;
    display: flex;
    flex-direction: column;
    max-width: 1300px;
    background: var(--input-bg, #e5e6eb);
    margin: 0 auto;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    height: calc(100vh - 20px);
    box-sizing: border-box;
  }
  .note-title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 22px;
    padding-right: 18px;
    background: var(--card-bg, #fff);

    .lesson-name {
      font-weight: 500;
      font-size: 16px;
      color: var(--text-primary, #1d2129);
      line-height: 22px;
      flex: 1;
      margin-right: 15px;
    }
    .download-btn {
      font-size: 22px;
      font-weight: bold;
      color: var(--text-primary, #1d2129);
      img {
        width: 20px;
        height: 20px;
        filter: var(--note-download-icon-filter);
        transition: filter 0.18s ease;
      }
      &:hover img {
        filter: var(--note-download-icon-hover-filter);
      }
    }
  }
  .editor-wrap {
    max-width: 1200px;
    width: 100%;
    margin: 12px auto;
    background: var(--card-bg, #fff);
    border-radius: 12px;
  }
}
.electron-note-page-wrap {
  --note-download-icon-filter: none;
  --note-download-icon-hover-filter: none;

  html.dark &,
  html.theme-dark &,
  html[data-theme="dark"] &,
  #app.dark &,
  #app.theme-dark & {
    --note-download-icon-filter: invert(0.72) brightness(1.45);
    --note-download-icon-hover-filter: invert(1);
  }

  .note-page-cont {
    display: flex;
    flex-direction: column;
    width: 1200px;
    height: calc(100vh - #{$top-bar-height} - 14px - 3px);
    margin: 3px auto 0;
    background: var(--card-bg, #ffffff);
    border-radius: 20px;
    overflow: hidden;
  }
  .note-title {
    height: 44px;
    background: var(--input-bg, #f7f8fa);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 13px;
    padding-right: 20px;
    .download-btn {
      font-size: 22px;
      font-weight: bold;
      color: var(--text-primary, #1d2129);
      img {
        width: 20px;
        height: 20px;
        filter: var(--note-download-icon-filter);
        transition: filter 0.18s ease;
      }
      &:hover img {
        filter: var(--note-download-icon-hover-filter);
      }
    }
  }
}
</style>
